import Cookies from 'js-cookie'

export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready(function () {
      $("#drawer-menu").mmenu({
        offCanvas: {
          position: 'right',
        },
        navbars: [{
          position: "top",
          height: 2,
          content: [
            "<div class='mm-brand-wrapper'><img src='/wp-content/themes/chikyujin/resources/assets/images/common/logo-white.png' alt='CHIKYUJIN' class='mm-brand' ></div>",
          ],
        }],
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $('#page').waypoint({
      handler: function () {
        $('.metabar').toggleClass('is-scrolled');
        $('.navbar-earthnoid').toggleClass('is-scrolled');
        $('.back2top').toggleClass('is-scrolled');
      },
      offset: '-40%',
    });

    // ページ内スクロール
    $('a.page-scroll').bind('click', function (event) {
      event.preventDefault();
      let speed = 600;
      let href = $(this).attr('href');
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top;
      $('html, body').stop().animate({ scrollTop: position }, speed, 'swing');
    });

    // お気に入り周りの処理
    $('.button--like').on('click', function (event) {
      event.preventDefault();

      let addedClass = 'is-liked';
      let postId = /(?:^|\s)post-(\d+)/g.exec($(this).parents('.recruitment').prop('class'))[1];
      let liked = Cookies.getJSON('liked');
      liked = liked ? liked : [];

      if (liked.indexOf(postId) === -1) {
        // 見つからなかったとき === 追加するとき
        liked.push(postId);
        $(this).addClass(addedClass).html('<i class="fa fa-heart-o" aria-hidden="true"></i> お気に入りから削除');
      } else {
        // 見つかったとき === 削除するとき
        liked.some(function (value, index) {
          if (value == postId) {
            liked.splice(index, 1);
          }
        });
        $(this).removeClass(addedClass).html('<i class="fa fa-heart" aria-hidden="true"></i> お気に入りに追加');
      }

      Cookies.set('liked', liked);
    });

    // ぴったり検索フォームのcheckboxの処理。
    // 親の選択肢を選択したときに子の選択肢を全てtoggleする。
    // なんかsearch.jsに入れてると調子悪いのでこっち移した
    $('.field-occupation--parent').on('change', function () {
      let children = '.field-occupation-child--parent-id-' + $(this).val();
      let toggle = $(this).attr('checked') ? true : false;
      $(children).attr('checked', toggle);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js